// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --input-height: 2.4rem;
  --toggle-width: 92%;
  --toggle-height: 2.4rem;
}

.form-item-content {
  display: flex;
  justify-content: space-between;
  min-height: 65px;
}

.form-item-label {
  flex: 0 0 12.5rem;
  font-weight: 600;
  font-size: 1rem;
  color: var(--color-primary);
  text-align: left;
  margin-right: 0.5rem;
}

.form-item-input {
  flex: 2;
}
.label-container {
  display: flex;
 
}

.required-symbol {
  margin-right: 4px; /* Adjust the spacing as needed */
}
.form-item-custom {
  margin: 0;
}

.form-item-input .ant-input,
.form-item-input .ant-picker {
  height: var(--input-height);
  width: 92%;
  box-sizing: border-box;
  border: 0.09375rem solid var(--color-primary);
  border-radius: 0.75rem;
  font-size: 16px;
  color: black;
}

.toggle-button {
  display: flex;
  align-items: center;
  width: var(--toggle-width);
  height: var(--toggle-height);
  border-radius: var(--toggle-height);
  border: 0.125rem solid #d9d9d9;
  overflow: hidden;
  cursor: pointer;
}

.toggle-option {
  flex: 1;
  text-align: center;
  line-height: var(--toggle-height);
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.divider {
  width: 0.125rem;
  height: 100%;
  background-color: #d9d9d9;
}

.toggle-option.active {
  background-color: var(--color-primary);
  color: #fff;
}

.ant-checkbox-wrapper {
  color:var(--color-primary);
  font-size: 1rem;
}

.ant-checkbox-wrapper .ant-checkbox + span {
  color: var(--color-primary);
  font-size: 1rem;
  font-weight: 600;
}

.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner::after {
  background-color: var(--color-primary) !important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border-color: var(--color-primary)!important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.ant-checkbox-wrapper .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}

.form-item-input .ant-form-item-explain {
  margin-top: 0.5rem;
}
.date-picker-transition {
  transition: all 0.3s ease-in-out;
  opacity: 1;
}

.date-picker-transition input {
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;
}

.date-picker-transition .ant-picker {
  transition: all 0.3s ease-in-out;
}

.date-picker-transition .ant-picker-focused {
  background-color: white; 
}
.date-picker-transition .ant-picker {
  transition: all 0.3s ease-in-out;
}
.ant-form-item .ant-form-item-explain-error {
  color: #ff4d4f;
  font-size: 10px;
  height: 1.5rem; 
}

.custom-datepicker .ant-picker-dropdown {
  width: 300px !important; /* Adjust the width */
  height: 400px !important; /* Adjust the height */
}

/* Optional: Customize the DatePicker input box */
.custom-datepicker .ant-picker {
  width: 100%; /* Adjust based on your layout */
  height: 40px; /* Adjust height for the input field */
}

@media (max-width: 768px) {
  .form-item-label {
    font-size: 0.875rem; 
    flex: 0 0 2rem; 
  }

  .form-item-content {
    flex-direction: column; 
    align-items: flex-start;
  }

  .form-item-input {
    width: 100%; 
  }

  .toggle-button {
    width: 100%; 
  }
}

@media (max-width: 576px) {
  .form-item-label {
    font-size: 0.75rem; 
  }

  .form-item-input .ant-input,
  .form-item-input .ant-picker {
    width: 100%;
  }

  .toggle-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/reporting/PreSurvey.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;AACA;EACE,aAAa;;AAEf;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;AACA;EACE,SAAS;AACX;;AAEA;;EAEE,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;EACtB,6CAA6C;EAC7C,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB,EAAE,qBAAqB;EAC9C,wBAAwB,EAAE,sBAAsB;AAClD;;AAEA,iDAAiD;AACjD;EACE,WAAW,EAAE,gCAAgC;EAC7C,YAAY,EAAE,sCAAsC;AACtD;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["\n:root {\n  --input-height: 2.4rem;\n  --toggle-width: 92%;\n  --toggle-height: 2.4rem;\n}\n\n.form-item-content {\n  display: flex;\n  justify-content: space-between;\n  min-height: 65px;\n}\n\n.form-item-label {\n  flex: 0 0 12.5rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--color-primary);\n  text-align: left;\n  margin-right: 0.5rem;\n}\n\n.form-item-input {\n  flex: 2;\n}\n.label-container {\n  display: flex;\n \n}\n\n.required-symbol {\n  margin-right: 4px; /* Adjust the spacing as needed */\n}\n.form-item-custom {\n  margin: 0;\n}\n\n.form-item-input .ant-input,\n.form-item-input .ant-picker {\n  height: var(--input-height);\n  width: 92%;\n  box-sizing: border-box;\n  border: 0.09375rem solid var(--color-primary);\n  border-radius: 0.75rem;\n  font-size: 16px;\n  color: black;\n}\n\n.toggle-button {\n  display: flex;\n  align-items: center;\n  width: var(--toggle-width);\n  height: var(--toggle-height);\n  border-radius: var(--toggle-height);\n  border: 0.125rem solid #d9d9d9;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.toggle-option {\n  flex: 1;\n  text-align: center;\n  line-height: var(--toggle-height);\n  font-size: 1rem;\n  transition: background-color 0.3s ease;\n}\n\n.divider {\n  width: 0.125rem;\n  height: 100%;\n  background-color: #d9d9d9;\n}\n\n.toggle-option.active {\n  background-color: var(--color-primary);\n  color: #fff;\n}\n\n.ant-checkbox-wrapper {\n  color:var(--color-primary);\n  font-size: 1rem;\n}\n\n.ant-checkbox-wrapper .ant-checkbox + span {\n  color: var(--color-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner::after {\n  background-color: var(--color-primary) !important;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner {\n  border-color: var(--color-primary)!important;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n.ant-checkbox-wrapper .ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n}\n\n.form-item-input .ant-form-item-explain {\n  margin-top: 0.5rem;\n}\n.date-picker-transition {\n  transition: all 0.3s ease-in-out;\n  opacity: 1;\n}\n\n.date-picker-transition input {\n  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;\n}\n\n.date-picker-transition .ant-picker {\n  transition: all 0.3s ease-in-out;\n}\n\n.date-picker-transition .ant-picker-focused {\n  background-color: white; \n}\n.date-picker-transition .ant-picker {\n  transition: all 0.3s ease-in-out;\n}\n.ant-form-item .ant-form-item-explain-error {\n  color: #ff4d4f;\n  font-size: 10px;\n  height: 1.5rem; \n}\n\n.custom-datepicker .ant-picker-dropdown {\n  width: 300px !important; /* Adjust the width */\n  height: 400px !important; /* Adjust the height */\n}\n\n/* Optional: Customize the DatePicker input box */\n.custom-datepicker .ant-picker {\n  width: 100%; /* Adjust based on your layout */\n  height: 40px; /* Adjust height for the input field */\n}\n\n@media (max-width: 768px) {\n  .form-item-label {\n    font-size: 0.875rem; \n    flex: 0 0 2rem; \n  }\n\n  .form-item-content {\n    flex-direction: column; \n    align-items: flex-start;\n  }\n\n  .form-item-input {\n    width: 100%; \n  }\n\n  .toggle-button {\n    width: 100%; \n  }\n}\n\n@media (max-width: 576px) {\n  .form-item-label {\n    font-size: 0.75rem; \n  }\n\n  .form-item-input .ant-input,\n  .form-item-input .ant-picker {\n    width: 100%;\n  }\n\n  .toggle-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
